import React, { useEffect, useState } from 'react';
import { X, Download } from 'lucide-react';
import './PDFModal.css';

const PDFModal = ({ pdfUrl, title, onClose }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    const onResize = () => setIsMobile(window.innerWidth <= 640);
    document.addEventListener('keydown', onKey);
    window.addEventListener('resize', onResize);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      window.removeEventListener('resize', onResize);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  const pdfSrc = `${pdfUrl}#toolbar=1&zoom=page-width`;

  return (
    <div className="pdf-modal-overlay" onClick={onClose}>
      <div className="pdf-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="pdf-modal-header">
          <span className="pdf-modal-title">{title}</span>
          <div className="pdf-modal-actions">
            <a href={pdfUrl} download className="pdf-modal-download">
              <Download size={16} />
              Descargar
            </a>
            <button className="pdf-modal-close" onClick={onClose} aria-label="Cerrar">
              <X size={20} />
            </button>
          </div>
        </div>
        <div className="pdf-modal-body">
          {isMobile ? (
            <embed
              src={pdfSrc}
              type="application/pdf"
              width="100%"
              height="100%"
              className="pdf-modal-iframe"
            />
          ) : (
            <iframe
              src={pdfSrc}
              title={title}
              className="pdf-modal-iframe"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PDFModal;
